import { render } from "./pay.vue?vue&type=template&id=2f0aea56&scoped=true&ts=true"
import script from "./pay.vue?vue&type=script&lang=ts"
export * from "./pay.vue?vue&type=script&lang=ts"

import "./pay.vue?vue&type=style&index=0&id=2f0aea56&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f0aea56"]])

export default __exports__